/** @format */
import { Routes } from '@angular/router';
import { ProductListPageResolveGuard } from './guards/product-list-page-resolve.guard';
import { SearchResultsListPageResolveGuard } from './guards/search-results-list-page-resolve.guard';
import { CategoryResolveGuard } from './guards/category-resolve.guard';

// /*
//  * Standalone App Routes
//  */
export const PRODUCT_LIST_APP_ROUTES: Routes = [
  {
    path: 'f/:seoToken',
    loadComponent: () =>
      import('./product-list/product-list-container/product-list-container.component').then(
        (m) => m.ProductListContainerComponent,
      ),
    providers: [ProductListPageResolveGuard],
    resolve: { productList: ProductListPageResolveGuard },
  },
  {
    path: 'search/SearchDisplay',
    loadComponent: () =>
      import('./product-list/product-list-container/product-list-container.component').then(
        (m) => m.ProductListContainerComponent,
      ),
    providers: [SearchResultsListPageResolveGuard],
    resolve: { productList: SearchResultsListPageResolveGuard },
  },
  {
    path: 'c/:seoToken',
    loadComponent: () =>
      import('./category/category-container/category-container.component').then(
        (m) => m.CategoryContainerComponent,
      ),
    providers: [CategoryResolveGuard],
    resolve: { categoryData: CategoryResolveGuard },
  },
];
